import ClaimElement from "components/ClaimElement";
import ClaimGraphicsDownload from "components/ClaimGraphicsDownload";
import React, { useEffect, useState } from "react";
import { formatDate } from "utils/function";

const ClaimChartDownload = ({
  newData,
  claimChartAPIData,
  imagesLoaded,
  setImagesLoaded,
}: any) => {
  const [todayDate, setTodayDate] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [projectName, setProjectName] = useState<string>("");

  useEffect(() => {
    const loadImages = async () => {
      const images = Array.from(document.querySelectorAll("img"));
      await Promise.all(
        images.map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) resolve(true);
              img.onload = resolve;
              img.onerror = resolve;
            })
        )
      );
      setImagesLoaded(true);
    };

    loadImages();
  }, []);

  const formatDownloadDate = (date: any) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const month = months[date.getMonth()]; // Get the month
    const day = date.getDate(); // Get the date
    const year = date.getFullYear(); // Get the year
    const dayOfWeek = days[date.getDay()]; // Get the day of the week

    // Get hours, minutes and determine AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Pad minutes with leading zero if necessary
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

    return `${month} ${day} ${year}, ${dayOfWeek} ${hours}:${formattedMinutes} ${ampm}`;
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDownloadDate(today);
    setTodayDate(formattedDate);
    const userData: any = JSON.parse(
      localStorage.getItem("userData") as string
    );

    setUserName(userData?.name || "");
    const headerData: any = JSON.parse(
      localStorage.getItem("headerData") as string
    );

    setProjectName(headerData?.projectDetail?.title || "");
  }, []);

  const formatCitationHeading = (data: any) => {
    const parts = [];
    if (data.paragraph_start_number && data.paragraph_start_number !== "None") {
      const label =
        data.paragraph_end_number && data.paragraph_end_number !== "None" && data.paragraph_start_number !== data.paragraph_end_number
          ? `Paragraph ${data.paragraph_start_number}-${data.paragraph_end_number}`
          : `Paragraph ${data.paragraph_start_number}`;
      return `Specification at ${label}`;
    }
    if (data.starting_page_number && data.starting_page_number !== "None") {
      parts.push(
        data.starting_page_number === data.ending_page_number
          ? `Page ${data.starting_page_number}`
          : `Pages ${data.starting_page_number}-${data.ending_page_number}`
      );
    }
    if (data.starting_column_number && data.starting_column_number !== "None") {
      parts.push(
        data.starting_column_number === data.ending_column_number
          ? `Column ${data.starting_column_number}`
          : `Columns ${data.starting_column_number}-${data.ending_column_number}`
      );
    }
    if (data.starting_line_number && data.starting_line_number !== "None") {
      parts.push(
        data.starting_line_number === data.ending_line_number
          ? `Line ${data.starting_line_number}`
          : `Lines ${data.starting_line_number}-${data.ending_line_number}`
      );
    }
    if (parts.length > 0) return `Specification at ${parts.join(", ")}`;
    if (data.file_url && data.file_name && !data.starting_line_number && !data.starting_page_number) return data.file_name;
    if (data.url && data.url.trim()) return data.url;
    return "Specification";
  };

  const formatCitationFileUrl = (data: any) => {
    if (data.file_url && data.file_url.trim()) {
      return data.starting_page_number ? `${data.file_url}#page=${data.starting_page_number}` : data.file_url;
    }
    if (data.url && data.url.trim()) return data.url;
    return null;
  };

  // Collect all citation numbers actually referenced in the chart text
  const getReferencedCitationNumbers = (): Set<number> => {
    const referenced = new Set<number>();
    const regex = /\[\[?(\d+(?:\s*,\s*\d+)*)\]?\]/g;

    const scanText = (text: string) => {
      let match;
      while ((match = regex.exec(text)) !== null) {
        match[1].split(",").forEach((n) => {
          const num = parseInt(n.trim(), 10);
          if (!isNaN(num)) referenced.add(num);
        });
      }
    };

    if (newData?.patents) {
      newData.patents.forEach((patent: any) => {
        Object.values(patent.summarized_similarity_results || {}).forEach((claimItems: any) => {
          (claimItems || []).forEach((item: any) => {
            [...(item.matched_items || []), ...(item.non_matched_items || [])].forEach((entry: any) => {
              const text = typeof entry === "object" && entry !== null ? entry.text || "" : entry || "";
              scanText(text);
            });
          });
        });
      });
    }

    return referenced;
  };

  const referencedCitationNumbers = getReferencedCitationNumbers();

  return (
    <div id="claim-chart-download" className="mb-10">
      <div id="cover-page">
        <div
        // style={{ borderCollapse: "collapse", border: "none", width: "100%" }}
        >
          <div className="px-6 py-6">
            <div className="">
              <img
                className="mb-1.5"
                src="https://demo-ipvijil-sample-images.s3.us-east-1.amazonaws.com/login_logo.svg"
                alt="mainLogo"
              />
              <p className="text-bse font-interSemiBold text-[#1A75FF] pb-2">
                Vijil Chart - For {claimChartAPIData?.name}
              </p>

              <div className="flex items-center gap-x-1.5">
                {/* <img
                src="https://demo-ipvijil-sample-images.s3.us-east-1.amazonaws.com/device-holder-icon.svg"
                alt="deviceHolderIcon"
              /> */}
                <span className="text-[#344051] text-xs font-interMedium">
                  Project : {projectName}
                </span>
              </div>
            </div>
            <div className="">
              <div className="">
                {/* <img
                src="https://demo-ipvijil-sample-images.s3.us-east-1.amazonaws.com/calendar-icon.svg"
                alt="calenderIcon"
              /> */}
                <span className="text-[#344051] text-xs font-interRegular">
                  Downloaded On : {todayDate}
                </span>
              </div>
              <div className="">
                {/* <img
                src="https://demo-ipvijil-sample-images.s3.us-east-1.amazonaws.com/user-profile-icon.svg"
                alt="userProfileIcon"
              /> */}
                <span className="text-[#344051] text-xs font-interRegular">
                  Downloaded By : {userName}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-10">
          <p className="text-xs italic text-[#7E7E7E] font-interRegular pb-2 mx-auto max-w-screen-lg text-center">
            ** All data has been generated using IPVijil’s AI Assist technology.
            It may need human verification before proceeding with legal
            action.**
          </p>

          <p className="text-center">
            <span className="text-[#1A75FF] font-interSemiBold text-xs">
              {" "}
              IPVijil.ai
            </span>
            <span className="text-[#7E8C9A] font-interRegular text-xs pl-2">
              {" "}
              AI powered IP Intelligence. © 2025 All Rights Reserved.
            </span>
          </p>
          {/* <p className="text-[#7E8C9A] font-interRegular text-xs">Page 1 of 3</p> */}
        </div>
      </div>

      <div className="page-break"></div>
      {newData.patents.map((patent: any) =>
        Object.entries(patent.claims).map(([claimKey, claim]: any) => (
          <>
            <div className="">
              <h3 className="text-lg font-interSemiBold text-[#000000] mb-2">
                {patent.patentNumber}
              </h3>
              <span className="text-lg font-interSemiBold text-[#000000]">
                Claim {claimKey.replace("claim", "")}
              </span>
            </div>

            <table className="">
              <tr
                key={`${patent.patentId}-${claimKey}`}
                className="claim w-full"
              >
                <th className="border border-[#CFD6DD] rounded-lg mb-3 pl-4 pr-3.5 w-[33%] align-top text-left font-normal">
                  <div className="mt-4 pr-3 pl-4">
                    <ClaimElement claim={claim} />
                  </div>
                </th>

                <th className="border border-[#CFD6DD] rounded-lg py-4 ml-2 mr-2 w-[33%] align-top text-left font-normal">
                  <div className="">
                    <div className="">
                      <ClaimGraphicsDownload claim={claim} />
                    </div>
                  </div>
                </th>

                <th className="px-4 py-4 border border-[#CFD6DD] rounded-lg w-[33%] align-top text-left font-normal">
                  <p className="text-base font-interSemiBold text-[#0A090B] pb-1">
                    Covered Patents
                  </p>
                  {patent.summarized_similarity_results &&
                  patent.summarized_similarity_results[claimKey] ? (
                    patent.summarized_similarity_results[claimKey].map(
                      (item: any, index: any) => (
                        <div
                          key={item.targetDocumentId + index}
                          className="mt-2 px-3 mb-4 last:mb-0"
                        >
                          <div className="border border-[#EAEDF0] rounded-sm">
                            <div className="px-3 py-3 relative">
                              <div className="bg-[#EDEDED] pb-3 pt-3 px-2 mb-4 rounded-md">
                                <div className="relative flex items-center gap-x-2 mb-3">
                                  <p className="text-sm hover:text-[#113B98] text-[#1751D0] underline">
                                    {item.targetDocumentId}
                                  </p>
                                </div>
                                {item.matched_items &&
                                  item.matched_items.length > 0 && (
                                    <>
                                      <div className="bg-white border border-[#D1D1DB] rounded-md p-3 mt-4">
                                        <p className="text-base font-interBold text-[#4F4D55] mb-3">
                                          Matched Items :{" "}
                                        </p>
                                        {item.matched_items.map(
                                          (matchedItem: any, index: any) => {
                                            const isObjectFormat =
                                              typeof matchedItem === "object" &&
                                              matchedItem !== null &&
                                              "text" in matchedItem;
                                            const textContent = isObjectFormat
                                              ? matchedItem.text
                                              : matchedItem;
                                            const hexColor = isObjectFormat
                                              ? matchedItem.element_hex_code
                                              : null;

                                            return (
                                              <p
                                                key={index}
                                                className="text-sm text-[#71717A] mb-3"
                                              >
                                                {hexColor ? (
                                                  <span
                                                    style={{ color: hexColor }}
                                                  >
                                                    {textContent}
                                                  </span>
                                                ) : (
                                                  textContent
                                                )}
                                              </p>
                                            );
                                          }
                                        )}
                                      </div>
                                      {item?.non_matched_items &&
                                        item?.non_matched_items.length > 0 && (
                                          <hr className="border-t border-[#E4E4E7] my-3" />
                                        )}
                                    </>
                                  )}
                                {item.non_matched_items &&
                                  item.non_matched_items.length > 0 && (
                                    <div className="bg-white border border-[#D1D1DB] rounded-md p-3 mt-4">
                                      <p className="text-base font-interBold text-[#4F4D55] mb-3 mt-3">
                                        Unmatched Items :{" "}
                                      </p>
                                      {item.non_matched_items.map(
                                        (unmatchedItem: any, index: any) => {
                                          const isObjectFormat =
                                            typeof unmatchedItem === "object" &&
                                            unmatchedItem !== null &&
                                            "text" in unmatchedItem;
                                          const textContent = isObjectFormat
                                            ? unmatchedItem.text
                                            : unmatchedItem;
                                          const hexColor = isObjectFormat
                                            ? unmatchedItem.element_hex_code
                                            : null;

                                          return (
                                            <p
                                              key={index}
                                              className="text-sm text-[#71717A] mb-3"
                                            >
                                              {hexColor ? (
                                                <span
                                                  style={{ color: hexColor }}
                                                >
                                                  {textContent}
                                                </span>
                                              ) : (
                                                textContent
                                              )}
                                            </p>
                                          );
                                        }
                                      )}
                                    </div>
                                  )}
                                <span className="text-sm text-black font-interMedium inline-block pb-3 mt-3">
                                  Overlap score
                                </span>
                                <div className="flex items-center gap-x-3 justify-between">
                                  <div className="bg-[#E4E4E7] h-2 w-[97%] relative rounded-lg">
                                    <div
                                      className="bg-[#005BC4] h-full absolute top-0 left-0 rounded-lg"
                                      style={{
                                        width: `${Math.round(item.score)}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <span className="font-interSemiBold text-black text-sm">
                                    {Math.round(item.score)}%
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <p className="flex justify-center items-center h-full mx-auto text-sm text-[#71717A] mb-3">
                      No Covered Patents Found
                    </p>
                  )}
                </th>
              </tr>
            </table>

            <div className="page-break"></div>
          </>
        ))
      )}
      <div className="page-break"></div>

      <div className="px-6">
        <h4 className="text-lg font-interMedium text-[#141C24] pt-3">
          Appendix
        </h4>

        {claimChartAPIData?.source?.length > 0 && (
          <>
            <div className="">
              <h5 className="text-base font-interMedium text-[#637083] py-4">
                Source
              </h5>

              {claimChartAPIData?.source?.map((item: any, index: number) => (
                <div
                  key={index}
                  className="border-[#F1F1F1] border-b pb-3 pt-3 first-of-type:pt-0 px-6"
                >
                  <p className="items-center flex gap-x-3 pb-1">
                    <span className="text-sm font-interSemiBold text-[#1751D0]">
                      {item.original_file_name}
                    </span>
                    {/* <span className="text-sm font-interRegular text-[#4F4D55]">{data.date}</span> */}
                  </p>
                  {/* <p className="text-sm font-interSemiBold text-[#7F7D83]">{data.sub_heading}</p> */}
                  <p>
                    <span className="text-[#ADACB0] text-xs font-interRegular">
                      {formatDate(item?.updatedAt)}
                    </span>
                    <span className="text-[#ADACB0] text-xs font-interRegular">
                      {" by "}
                      {item?.user_id?.name}
                    </span>
                  </p>
                </div>
              ))}
            </div>
          </>
        )}

        {claimChartAPIData?.compare?.length > 0 && (
          <>
            <div className="">
              <h5 className="text-base font-interMedium text-[#637083] py-4">
                Compare
              </h5>

              {claimChartAPIData?.compare?.map((item: any, index: number) => (
                <div
                  key={index}
                  className="border-[#F1F1F1] border-b pb-3 pt-3 first-of-type:pt-0 px-6"
                >
                  <p className="items-center flex gap-x-3 pb-1">
                    <span className="text-sm font-interSemiBold text-[#1751D0]">
                      {item.original_file_name}
                    </span>
                  </p>
                  <p>
                    <span className="text-[#ADACB0] text-xs font-interRegular">
                      {formatDate(item?.updatedAt)}
                    </span>
                    <span className="text-[#ADACB0] text-xs font-interRegular">
                      {" by "}
                      {item?.user_id?.name}
                    </span>
                  </p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {claimChartAPIData?.citations?.filter((c: any) => referencedCitationNumbers.has(c.number)).length > 0 && (
        <>
          <div className="page-break"></div>
          <div className="px-6 pb-10">
            <h4 className="text-lg font-interMedium text-[#141C24] pt-3 pb-2 border-b border-[#E4E4E7] mb-4">
              Citations
            </h4>
            {claimChartAPIData.citations
              .filter((c: any) => referencedCitationNumbers.has(c.number))
              .sort((a: any, b: any) => a.number - b.number)
              .map((citation: any, index: number) => {
              const heading = formatCitationHeading(citation);
              const fileUrl = formatCitationFileUrl(citation);
              return (
                <div
                  key={index}
                  className="border-b border-[#F1F1F1] pb-3 pt-3 first-of-type:pt-0"
                >
                  <div className="flex items-start gap-x-3">
                    <span className="text-sm font-interSemiBold text-[#1751D0] flex-shrink-0 min-w-[24px]">
                      [{citation.number}]
                    </span>
                    <div className="flex-1">
                      <p className="text-sm font-interSemiBold text-[#0A090B] pb-0.5">
                        {heading}
                      </p>
                      {citation.description && (
                        <p className="text-sm text-[#4F4D55] font-interRegular">
                          {citation.description}
                        </p>
                      )}
                      {fileUrl && (
                        <p className="text-xs text-[#1751D0] font-interRegular mt-0.5 break-all">
                          {fileUrl}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default ClaimChartDownload;
